export enum Report {
  Contacts = 'contacts',
  Lending = 'lending',
  Opportunities = 'opportunity',
  Products = 'products',
  Refixes = 'refix',
  EmailCampaignMetrics = 'canvas-metrics'
}
